
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/regulatory-changes/adopted-regulation-bulletin",
      function () {
        return require("private-next-pages/compliance/regulatory-changes/adopted-regulation-bulletin/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/regulatory-changes/adopted-regulation-bulletin"])
      });
    }
  